import { Role } from './loginRole';

export const isSuperAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

export const isClinicAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.ClinicAdmin || loginUserRoleId === Role.CareManager;
};

export const isMultiSiteRater = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.MultiSiteRater;
};

export const isMultiSiteStudyAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.MultiSiteStudyAdmin;
};

export const isAccountStudyAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.AccountStudyAdmin;
};

export const isRater = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.Rater;
};

export const isAuditor = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.Auditor;
};

export const isSiteStudyAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SiteStudyAdmin;
};

export const isClinicalStudyUser = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.AccountStudyAdmin ||
    loginUserRoleId === Role.MultiSiteStudyAdmin ||
    loginUserRoleId === Role.SiteStudyAdmin ||
    loginUserRoleId === Role.MultiSiteRater ||
    loginUserRoleId === Role.Rater ||
    loginUserRoleId === Role.Auditor
  );
};

export const canDeleteInterviewOrPatient = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiSiteAdmin ||
    loginUserRoleId === Role.SiteAdmin ||
    loginUserRoleId === Role.Interviewer ||
    loginUserRoleId === Role.PsychiatricConsult ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.SingleUserProvider
  );
};

export const canEditUser = (editUserRoleId: number, loginUserRoleId: number): boolean => {
  // Super admins can edit all users
  if (loginUserRoleId === Role.SuperAdmin) {
    return true;
  }

  if (
    isClinicAdmin(loginUserRoleId) &&
    (editUserRoleId === Role.MultiSiteAdmin ||
      editUserRoleId === Role.MultiSiteStudyAdmin ||
      editUserRoleId === Role.SiteAdmin ||
      editUserRoleId === Role.Interviewer ||
      editUserRoleId === Role.MultiSiteRater ||
      isSiteStudyAdmin(editUserRoleId) ||
      isRater(editUserRoleId) ||
      editUserRoleId === Role.PsychiatricConsult ||
      editUserRoleId === Role.MultiUserProvider ||
      editUserRoleId === Role.SingleUserProvider)
  ) {
    return true;
  }

  if (
    loginUserRoleId === Role.MultiSiteAdmin &&
    (editUserRoleId === Role.SiteAdmin ||
      editUserRoleId === Role.Interviewer ||
      editUserRoleId === Role.MultiSiteRater ||
      isSiteStudyAdmin(editUserRoleId) ||
      isRater(editUserRoleId) ||
      editUserRoleId === Role.PsychiatricConsult)
  ) {
    return true;
  }

  if (
    loginUserRoleId === Role.AccountStudyAdmin &&
    (editUserRoleId === Role.MultiSiteStudyAdmin ||
      editUserRoleId === Role.SiteStudyAdmin ||
      editUserRoleId === Role.MultiSiteRater ||
      editUserRoleId === Role.Rater ||
      editUserRoleId === Role.Auditor)
  ) {
    return true;
  }

  if (
    loginUserRoleId === Role.MultiSiteStudyAdmin &&
    (isMultiSiteRater(editUserRoleId) || isSiteStudyAdmin(editUserRoleId) || isRater(editUserRoleId))
  ) {
    return true;
  }

  if (
    loginUserRoleId === Role.SiteStudyAdmin && isRater(editUserRoleId)
  ) {
    return true;
  }

  if (
    (loginUserRoleId === Role.SiteAdmin || loginUserRoleId === Role.SingleUserProvider) &&
    (editUserRoleId === Role.Interviewer || editUserRoleId === Role.PsychiatricConsult || isRater(editUserRoleId))
  ) {
    return true;
  }

  if (
    loginUserRoleId === Role.MultiUserProvider &&
    (editUserRoleId === Role.Interviewer ||
      editUserRoleId === Role.MultiSiteRater ||
      isRater(editUserRoleId) ||
      editUserRoleId === Role.SingleUserProvider ||
      editUserRoleId === Role.PsychiatricConsult)
  ) {
    return true;
  }

  return false;
};

export const canViewOrAddUser = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    isAccountStudyAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.MultiSiteAdmin ||
    loginUserRoleId === Role.MultiSiteStudyAdmin ||
    loginUserRoleId === Role.SingleUserProvider ||
    loginUserRoleId === Role.SiteAdmin ||
    isSiteStudyAdmin(loginUserRoleId)
  );
};
/**
 * Report
 */
export const canViewUsageReport = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.SingleUserProvider ||
    isAccountStudyAdmin(loginUserRoleId) ||
    isAuditor(loginUserRoleId)
  );
};
/**
 * Report
 */
export const canViewAuditLog = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.MultiSiteAdmin ||
    loginUserRoleId === Role.MultiSiteStudyAdmin ||
    loginUserRoleId === Role.SingleUserProvider ||
    loginUserRoleId === Role.SiteAdmin ||
    isAccountStudyAdmin(loginUserRoleId) ||
    isSiteStudyAdmin(loginUserRoleId) ||
    isAuditor(loginUserRoleId)
  );
};

/**
 * Site
 */

export const canViewSites = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.MultiSiteAdmin ||
    loginUserRoleId === Role.MultiSiteStudyAdmin ||
    loginUserRoleId === Role.SingleUserProvider ||
    isAccountStudyAdmin(loginUserRoleId)
  );
};

export const canAddSite = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    isAccountStudyAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider
  );
};

export const canEditSite = (loginUserRoleId: number) => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiSiteAdmin ||
    loginUserRoleId === Role.MultiSiteStudyAdmin ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.SingleUserProvider ||
    isAccountStudyAdmin(loginUserRoleId)
  );
};

/**
 * Add SSO Client
 */
export const canAddEditSsoClient = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Account
 */

export const canViewAccounts = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

export const canAddOrEditAccounts = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Export
 */

export const canViewExportPage = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.SingleUserProvider ||
    isAccountStudyAdmin(loginUserRoleId) ||
    isAuditor(loginUserRoleId)
  );
};

/**
 *  Import Interviews
 */

export const canViewImportInterviewPage = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 *  Interview Menu
 */

export const canViewInterviewMenu = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Interviews
 */

export const canViewInterviewPage = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Import
 */

export const canViewImportPatientPage = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    loginUserRoleId === Role.SingleUserProvider ||
    isAccountStudyAdmin(loginUserRoleId)
  );
};

/**
 * Management Report
 */
export const canViewManagementReport = (
  loginUserRoleId: number,
  showManagementReport: boolean
): boolean => {
  return (
    showManagementReport && (loginUserRoleId === Role.SuperAdmin || isClinicAdmin(loginUserRoleId))
  );
};

/**
 * Data Structured Page
 */
export const canViewDataStructuredPage = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.SingleUserProvider ||
    loginUserRoleId === Role.MultiUserProvider ||
    isAccountStudyAdmin(loginUserRoleId)
  );
};

/**
 * Rescore Interviews
 */
export const canViewRescoreInterviewPage = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Clinical Follow-Ups
 */
export const canViewClinicalFollowupsPage = (loginUserRoleId: number): boolean => {
  return (
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.SuperAdmin ||
    loginUserRoleId === Role.MultiSiteAdmin
  );
};

export const canManagePatientClinicalFollowups = (loginUserRoleId: number): boolean => {
  return !(isMultiSiteStudyAdmin(loginUserRoleId) || isAuditor(loginUserRoleId));
};

/**
 * menu Clinical Follow-Ups
 */
export const canViewMenuClinicalFollowupsPage = (loginUserRoleId: number): boolean => {
  return isClinicAdmin(loginUserRoleId) || loginUserRoleId === Role.MultiSiteAdmin;
};

/**
 * Account Settings
 */
export const canViewAccountSettingsPage = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.MultiUserProvider ||
    isAccountStudyAdmin(loginUserRoleId)
  );
};

export const canAddEditTemplate = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Interview and Monitor builder
 */
export const canViewBuilder = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

/**
 * Billing Report
 */
export const canViewBillingReport = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId)
  );
};

/**
 * Master Usage Report
 */
export const canViewMasterUsageReport = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

export const canResetCache = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

export const canViewApiKey = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin || isClinicAdmin(loginUserRoleId);
};

export const canViewBySuperAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin;
};

export const isCareManagerOrSuperAdmin = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin || loginUserRoleId === Role.CareManager;
};

export const isCareManager = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.CareManager;
};

export const canManageCareTeam = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    loginUserRoleId === Role.ClinicAdmin ||
    loginUserRoleId === Role.CareManager
  );
};

export const canChangeFlagPatient = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin || loginUserRoleId === Role.CareManager;
};

export const canReactivatePatient = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin || loginUserRoleId === Role.CareManager || loginUserRoleId === Role.AccountStudyAdmin;
};

export const canDeactivateOrReactivateInterview = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    loginUserRoleId === Role.ClinicAdmin ||
    loginUserRoleId === Role.CareManager ||
    loginUserRoleId === Role.AccountStudyAdmin
  );
};

export const isQuickSightReportEnabled = process.env.REACT_APP_QUICKSIGHT_REPORT_ENABLED === 'true';

/**
 * Time Tracker Page
 */
export const canViewTimeTracker = (loginUserRoleId: number): boolean => {
  return (
    loginUserRoleId === Role.SuperAdmin ||
    isClinicAdmin(loginUserRoleId) ||
    loginUserRoleId === Role.PsychiatricConsult ||
    loginUserRoleId === Role.CareManager
  );
};

/**
 * Contacts Page
 */
export const canViewContactsPage = (loginUserRoleId: number): boolean => {
  return loginUserRoleId === Role.SuperAdmin || isClinicAdmin(loginUserRoleId);
};

export const isTakeScreenshotEnabled = process.env.REACT_APP_TAKE_SCREENSHOT_ENABLED === 'true';

export const canAddOrEditPatient = (loginUserRoleId: number): boolean => {
  return !isAuditor(loginUserRoleId)
};

export const canConductAssessment = (loginUserRoleId: number): boolean => {
  return !isAuditor(loginUserRoleId);
};

export const canManageTreatmentPlan = (loginUserRoleId: number): boolean => {
  return !isAuditor(loginUserRoleId);
};
